import { withStyles } from "@material-ui/core/styles";
import { BarGraphQA } from "./bargraph_QA.component";

export const StyledBarGraphQA = withStyles((theme) => ({
  root: {
    width: "440px",
    minWidth: "min-content",
    display: "block",
    background:
      "rgb(255,255,255)",

    "& > *": {
      margin: "10px",
      width: "min-content"
    }
  },
  title: {
    width: "440",
    paddingLeft: "5px",
    paddingRight: "0",
    fontSize: "30px",
    fontWeight: "bold",
    width:"auto",
    margin: "auto",
    height: "auto",
    textAlign: "left",
    color: "black",
    padding: "10px"
  },
  title2: {
    width:"auto",
    fontSize:"18px",
    margin: "auto",
    textAlign: "center",
    fontWeight: "bold",
    color: "black",
    padding: "10px"
  },
  num:{
    

    width: "440px",
    fontSize:"18px",
    margin: "auto",
    textAlign: "center",
    fontWeight: "bold",
    color: "black",
    padding: "10px"
  },
  svgText: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    fill: "white"
  }
}))(BarGraphQA);
